(function () {
  var dialog = document.getElementById('podtacek-offer');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var eligible = (dialog.getAttribute('data-eligible') || '').split(',').filter(Boolean);
  var offerProductId = dialog.getAttribute('data-offer-product-id');
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var select = dialog.querySelector('[data-podtacek-variant]');
  var priceEl = dialog.querySelector('[data-podtacek-price]');
  var imageEl = dialog.querySelector('[data-podtacek-image]');
  var msgEl = dialog.querySelector('[data-podtacek-msg]');
  var addBtn = dialog.querySelector('[data-podtacek-add]');
  var cartLink = dialog.querySelector('[data-podtacek-cart]');
  var KEY = 'podtacekOfferDismissed';

  function isDismissed() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function setDismissed() {
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }

  function syncVariant() {
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    priceEl.textContent = opt.getAttribute('data-price') || '';
    var img = opt.getAttribute('data-image');
    if (img && imageEl) imageEl.src = img;
  }

  function showMessage(text, isError) {
    msgEl.textContent = text;
    msgEl.hidden = !text;
    msgEl.classList.toggle('podtacek-offer__msg--error', !!isError);
  }

  function resetState() {
    showMessage('');
    addBtn.hidden = false;
    addBtn.removeAttribute('aria-disabled');
    cartLink.hidden = true;
    select.disabled = false;
    syncVariant();
  }

  function updateCartBubble(sections) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !sections || !sections['cart-icon-bubble']) return;
    var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var inner = doc.querySelector('.shopify-section');
    if (inner) bubble.innerHTML = inner.innerHTML;
  }

  function addToCart() {
    if (addBtn.getAttribute('aria-disabled') === 'true') return;
    addBtn.setAttribute('aria-disabled', 'true');
    showMessage('');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(select.value), quantity: 1, sections: 'cart-icon-bubble' })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          showMessage(res.description || res.message || 'Nepodarilo sa pridať do košíka.', true);
          addBtn.removeAttribute('aria-disabled');
          return;
        }
        updateCartBubble(res.sections);
        select.disabled = true;
        addBtn.hidden = true;
        cartLink.hidden = false;
        showMessage('Pridané do košíka ✓');
      })
      .catch(function () {
        showMessage('Nepodarilo sa pridať do košíka.', true);
        addBtn.removeAttribute('aria-disabled');
      });
  }

  function maybeShow(productId) {
    if (!productId || eligible.indexOf(String(productId)) === -1) return;
    if (isDismissed() || dialog.open) return;
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var already = cart.items.some(function (i) {
          return String(i.product_id) === String(offerProductId);
        });
        if (already) return;
        resetState();
        dialog.showModal();
      })
      .catch(function () {});
  }

  select.addEventListener('change', syncVariant);
  addBtn.addEventListener('click', addToCart);
  dialog.querySelectorAll('[data-podtacek-close]').forEach(function (btn) {
    btn.addEventListener('click', function () { dialog.close(); });
  });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  dialog.addEventListener('close', setDismissed);
  document.addEventListener('podtacek:offer', function (e) {
    maybeShow(e.detail && e.detail.productId);
  });

  syncVariant();
})();
